import { Component, OnInit } from '@angular/core';

import { ReporteDinamicoService } from '../reporte-dinamico.service';
import { LoginService } from '../../../login/login.service';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { PeriodoEjercicioService } from '../../../control/periodo.service';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
@Component({
  selector: 'app-ctb-balanza-comprobacion-din',
  templateUrl: './ctb-balanza-comprobacion-din.component.html',
  styleUrls: ['./ctb-balanza-comprobacion-din.component.css'],
    providers: [ReporteDinamicoService],
})
export class CtbBalanzaComprobacionDinComponent implements OnInit {

   public busqueda: any = {
     _gral_emp_id: 0,
     _year: 0,
     _month: 0
   };
   cuentaSeleccionada: string | null = null; 
  private empresa_info_actual: any;
   public ejercicios: any[] = [];
public fechaReporte = new Date();
   public reporteData: any[] = [];
 
   constructor(private reporteDinamicoService: ReporteDinamicoService, private loginService: LoginService, private PeriodoEjercicioService: PeriodoEjercicioService, private router: Router) { }
 
   ngOnInit(): void {
    
    this.empresa_info_actual = this.loginService.empresa_info_actual;
    this.ejercicios = this.loginService.ejercicios;
    this.busqueda._gral_emp_id = this.loginService.empresa;
    const currentMonth = new Date().getMonth() + 1;
    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.busqueda._year = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.busqueda._month = periodo ? periodo : 13;
      });
    this.cargarReporte();
   }
 
 
   cargarReporte() {
     console.log('Cargando reporte para:', this.busqueda);
     // Lógica para cargar el reporte basado en this.busqueda
     this.reporteDinamicoService.ctb_reporte_balanza_comprobacion_din(this.busqueda._year, this.busqueda._month, this.busqueda._gral_emp_id).
     subscribe(data => {
       console.log('Datos del reporte:', data);
       this.reporteData = data.data;
     });
 
   }
 
  exportAsXLSX() {
  console.log('Exportando como XLSX para:', this.busqueda);

  // Datos del reporte
  const datosExcel = this.reporteData.map(item => ({
    'Cuenta': item.ba_cuenta,
    'Nombre': item.ba_nombre,
    'Cargo Inicial': item.ba_cargo_ini,
    'Abono Inicial': item.ba_abono_ini,
    'Cargo Mes': item.ba_cargo_mens,
    'Abono Mes': item.ba_abono_mens,
    'Cargo Final': item.ba_cargo_fin,
    'Abono Final': item.ba_abono_fin,
    'Nivel': item.ba_nivel
  }));

  // Crear hoja con los datos
  // 1️⃣ Crear hoja vacía
const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]); // hoja vacía

// 2️⃣ Agregar los datos desde A7
XLSX.utils.sheet_add_json(ws, datosExcel, { origin: 'A7', skipHeader: false });

  // Información superior (título)
  const info = [
    ['BALANZA DE COMPROBACIÓN A ' + this.busqueda._year + ' - ' + this.busqueda._month],
    ['Empresa:', this.empresa_info_actual.titulo],
    ['RFC:', this.empresa_info_actual.rfc],
    ['Fecha:', this.fechaReporte.toLocaleDateString()],
    []
  ];

  // Insertar título al inicio
  XLSX.utils.sheet_add_aoa(ws, info, { origin: 'A1' });

  // Ajustar ancho de columnas
  ws['!cols'] = [
    { wch: 15 },
    { wch: 40 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 10 }
  ];

  // Combinar celdas del título
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } } // Título centrado
  ];

  // Crear libro
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Balanza Comprobación');

  // Exportar archivo
  XLSX.writeFile(
    wb,
    this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_balanza_comprobacion_${this.fechaReporte.toISOString().split('T')[0]}.xlsx`
  );
}

 
   exportAsPDF() {
    const doc = new jsPDF('landscape', 'pt', 'letter');
    const fecha = new Date().toLocaleDateString();
    
       // Título principal
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('BALANZA DE COMPROBACIÓN A ' + this.busqueda._year + ' - ' + this.busqueda._month, doc.internal.pageSize.width / 2, 50, { align: 'center' });
    
    // Fecha y datos de empresa (puedes personalizar)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${fecha}`, 40, 80);
    doc.text('Empresa: '+this.empresa_info_actual.titulo, 40, 100);
    doc.text('RFC: '+this.empresa_info_actual.rfc, 40, 120);
    
    // Preparar datos para la tabla
    const datosTabla = this.reporteData.map(item => [
      ' '.repeat(item.ba_nivel) + item.ba_cuenta,
      ' '.repeat(item.ba_nivel) + item.ba_nombre,
      this.formatCurrency(item.ba_cargo_ini),
      this.formatCurrency(item.ba_abono_ini),
      this.formatCurrency(item.ba_cargo_mens),
      this.formatCurrency(item.ba_abono_mens),
      this.formatCurrency(item.ba_cargo_fin),
      this.formatCurrency(item.ba_abono_fin)
    ]);
    const startY = 140;
    // Crear tabla con autoTable
    autoTable(doc, {
      head: [
        ['Cuenta', 'Nombre', 'Cargo Inicial', 'Abono Inicial', 
         'Cargo Mes', 'Abono Mes', 'Cargo Final', 'Abono Final']
      ],
      body: datosTabla,
      startY: startY,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: {  },
        1: {  },
        2: {  halign: 'right' },
        3: {  halign: 'right' },
        4: {  halign: 'right' },
        5: {  halign: 'right' },
        6: {  halign: 'right' },
        7: {  halign: 'right' }
      },
      margin: { horizontal: 14 },
      didParseCell: function(data) {
        // Formato para columnas numéricas
        const columnasNumericas = [2, 3, 4, 5, 6, 7];
        if (data.column.index > 1 && data.column.index < 8) {
          data.cell.styles.halign = 'right';
        }
      }
    });

    // Pie de página
    const pageCount = (doc as any).internal.getNumberOfPages();
    for(let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(
        `Página ${i} de ${pageCount}`, 
        doc.internal.pageSize.width / 2, 
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // Guardar PDF
    doc.save(this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_balanza_comprobacion_${this.fechaReporte.toISOString().split('T')[0]}.pdf`);
  }
  onWheel(event: WheelEvent) {
  const container = event.currentTarget as HTMLElement;
  container.scrollTop += event.deltaY; // scroll vertical
  // Si quieres scroll horizontal con Shift presionado:
  if (event.shiftKey) {
    container.scrollLeft += event.deltaY;
  }
  event.preventDefault(); // evita que el scroll se propague
}
  // Método para calcular totales (opcional, para agregar al final)
  calcularTotalesPDF(): any {
    // Esta función se puede usar para agregar una fila de totales al PDF
    const totales = {
      cargoInicial: this.reporteData.reduce((sum, item) => sum + (item.ba_cargo_ini || 0), 0),
      abonoInicial: this.reporteData.reduce((sum, item) => sum + (item.ba_abono_ini || 0), 0),
      cargoMes: this.reporteData.reduce((sum, item) => sum + (item.ba_cargo_mens || 0), 0),
      abonoMes: this.reporteData.reduce((sum, item) => sum + (item.ba_abono_mens || 0), 0),
      cargoFinal: this.reporteData.reduce((sum, item) => sum + (item.ba_cargo_fin || 0), 0),
      abonoFinal: this.reporteData.reduce((sum, item) => sum + (item.ba_abono_fin || 0), 0)
    };
    
    return totales;
  }
  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    }).format(value);
  }


abrirAuxiliar(cuenta: string) {
  this.cuentaSeleccionada = cuenta;
   const params = new URLSearchParams();
params.set('mes', this.busqueda._month.toString());
params.set('ano', this.busqueda._year.toString());
params.set('cuenta', cuenta);
  const url = `/#/contabilidad/reporte/rep-mov?${params.toString()}`;

  const width = window.screen.width * 0.8;   // ancho de la ventana (50%)
const height = window.screen.height * 0.8; // alto de la ventana (50%)

// Calculamos la posición centrada
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const ventana = window.open(
  url,
  'VisualizarCuenta',
  `top=${top},left=${left},width=${width},height=${height},resizable=yes,scrollbars=yes`
);
}

}
